import { Box, Button, Typography } from "@mui/material";
import TestJigsawDieLineOverlay from "./TestJigsawDieLineOverlay";
import { BOARD_SIZE, PieceVisual } from "./TestPieceVisual";

/** Copy of pages jigsaw CanvasBoard for admin canvas tests. */
export default function TestCanvasBoard({
    boardRef,
    boardPieces,
    grid,
    imageUrl,
    paths,
    svgPathFallback,
    dragging,
    showDragOutline,
    headerTitle = "Board",
    placedCount,
    total,
    isSolved,
    onReset,
    onBoardPieceMouseDown,
    showPieceGridCoords = false,
}) {
    return (
        <Box sx={{ width: BOARD_SIZE }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
                <Typography variant="subtitle2">
                    {headerTitle} ({placedCount}/{total})
                </Typography>
                <Button size="small" variant="outlined" onClick={onReset}>
                    Reset
                </Button>
                {placedCount === total && isSolved && (
                    <Typography variant="subtitle2" color="success.main" sx={{ fontWeight: 700 }}>
                        Solved!
                    </Typography>
                )}
            </Box>
            <Box
                ref={boardRef}
                sx={{
                    position: "relative",
                    width: BOARD_SIZE,
                    height: BOARD_SIZE,
                    bgcolor: "grey.800",
                    borderRadius: 1,
                    overflow: "visible",
                    outline: (showDragOutline !== undefined ? showDragOutline : Boolean(dragging))
                        ? "2px dashed #3BA666"
                        : "none",
                    outlineOffset: 0,
                }}
            >
                <TestJigsawDieLineOverlay pieces={paths} opacity={0.3} svgPathFallback={svgPathFallback} />
                {boardPieces.map((b, idx) => {
                    if (dragging?.boardId === b.id) return null;
                    return (
                        <div
                            key={b.id}
                            onMouseDown={(e) =>
                                onBoardPieceMouseDown(e, b.pieceIndex, {
                                    boardId: b.id,
                                    boardX: b.x,
                                    boardY: b.y,
                                })
                            }
                            style={{
                                position: "absolute",
                                left: b.x,
                                top: b.y,
                                cursor: "grab",
                                zIndex: 1 + idx,
                            }}
                        >
                            <PieceVisual
                                pieceIndex={b.pieceIndex}
                                imageUrl={imageUrl}
                                grid={grid}
                                paths={paths}
                                showGridCoords={showPieceGridCoords}
                            />
                        </div>
                    );
                })}
            </Box>
        </Box>
    );
}
